import React from 'react';
import { Link } from 'react-router-dom';
import { UserAccessEvent } from '../util/userAccessApi';

type AccessEventsTableProps = {
  events: UserAccessEvent[];
  emptyMessage: string;
};

const formatTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }
  return date.toLocaleString('sk-SK');
};

function AccessEventsTable({ events, emptyMessage }: AccessEventsTableProps) {
  if (events.length === 0) {
    return <div className="mt-4">{emptyMessage}</div>;
  }

  return (
    <div className="mt-4 overflow-auto rounded border border-amber-200 bg-white">
      <table className="min-w-full text-left">
        <thead className="bg-amber-100">
          <tr>
            <th className="p-3">Čas</th>
            <th className="p-3">User ID</th>
            <th className="p-3">Meno</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => (
            <tr key={event.id} className="border-t border-amber-100">
              <td className="p-3 whitespace-nowrap">{formatTimestamp(event.timestamp)}</td>
              <td className="p-3 whitespace-nowrap">
                {event.userRegistryId ? (
                  <Link className="text-amber-700 underline" to={`/userAccessUsers/${event.userRegistryId}`}>
                    {event.userid}
                  </Link>
                ) : (
                  event.userid
                )}
              </td>
              <td className="p-3 whitespace-nowrap">{event.name || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AccessEventsTable;
